import React from "react";
import {
  Routes,
  Route,
  Outlet,
  useParams
} from "react-router-dom";
import ClientContext from '../../providers/CurrentClientProvider'
import ClientService from '../../services/ClientService'

function ClientMiddleware() {
  const client_context = ClientContext.useClient();
  const {client_code} = useParams()

  async function getClientByCode() {
      const _client = await ClientService.getClientByCode(client_code)
      client_context.setClient(_client)
  }

  React.useEffect(() => {
    getClientByCode()
  }, [client_code])
  
  return <Outlet />
}

export default ClientMiddleware